import { useSaveIsAuthenticated } from "core/hooks/use-is-authenticated"
import { useClerk } from "@clerk/nextjs"
import { useSessionState } from "core/hooks"
import { usePreferredWorkspaceStore } from "core/hooks/use-preferred-workspace-store"
import posthog from "posthog-js"

export const useSignOut = () => {
  const saveIsAuthenticated = useSaveIsAuthenticated()

  let signOut: undefined | ReturnType<typeof useClerk>["signOut"]
  try {
    signOut = useClerk().signOut
  } catch (e) {
    // clerk not loaded...
  }

  return async () => {
    posthog.capture("user_signed_out")
    posthog.reset()

    saveIsAuthenticated(false)
    if (signOut) await signOut()
    useSessionState.persist.clearStorage()
    usePreferredWorkspaceStore.persist.clearStorage()
    window.location.href = "/signin"
  }
}
